import { useModelService } from "@shared/services/api/hooks/useModelService";
import { PublicUserClaimSerializerType } from "@shared/modules/auth/serializer-types";
import { ExtendedAxiosRequestConfig } from "@shared/services/api/abstracts/Repository";
import { UseQueryOptions } from "react-query";
import PublicUserClaimRepository from "../repositories/PublicUserClaimRepository";

const usePublicUserClaimService = () => {
  const repository = new PublicUserClaimRepository();

  const { useCreate, useRetrieve, useList, useGenericQuery } =
    useModelService(repository);

  const useFufillClaims = ({
    params,
    config,
    options,
  }: {
    params?: Record<string, unknown>;
    config?: ExtendedAxiosRequestConfig;
    options?: UseQueryOptions<PublicUserClaimSerializerType>;
  } = {}) => {
    return useGenericQuery<PublicUserClaimSerializerType>("retrieve", {
      params,
      config,
      options,
    });
  };

  return {
    useRetrieve,
    useCreate,
    useList,
    useFufillClaims,
  };
};

export default usePublicUserClaimService;
